"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TectonicCoreV8StorageFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [],
        name: "_borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "_mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "accountAssets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "allMarkets",
        outputs: [
            {
                internalType: "contract TToken",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowCapGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowCaps",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "borrowGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "closeFactorMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lastContributorBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationIncentiveMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "markets",
        outputs: [
            {
                internalType: "bool",
                name: "isListed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "collateralFactorMantissa",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "isTonicized",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxAssets",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "mintGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract PriceOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseGuardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingTectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "seizeGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCoreImplementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicVaultContract",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenToPerUserTvlProtectLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicAccrued",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicBorrowerIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicContributorSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplierIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplySpeeds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tonicSupplyState",
        outputs: [
            {
                internalType: "uint224",
                name: "index",
                type: "uint224",
            },
            {
                internalType: "uint32",
                name: "block",
                type: "uint32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultAmountCap",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultLastBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tonicToVaultSpeed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "transferGuardianPaused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "utilizedTvlAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "whitelistProtectEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedAddresses",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TectonicCoreV8StorageFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TectonicCoreV8StorageFactory = TectonicCoreV8StorageFactory;
TectonicCoreV8StorageFactory.bytecode = _bytecode;
TectonicCoreV8StorageFactory.abi = _abi;
//# sourceMappingURL=TectonicCoreV8StorageFactory.js.map